import { useEffect } from 'react';
import { currentLang } from '../i18n';

const SEO = ({ title, description, path, type = 'website', image, jsonLd }) => {
  const siteUrl = 'https://www.padsmash.com';
  const langPrefix = currentLang === 'fr' ? '' : `/${currentLang}`;
  const fullUrl = path ? `${siteUrl}${langPrefix}${path === '/' ? (langPrefix ? '' : '/') : path}` : `${siteUrl}${langPrefix || ''}`;
  const fullTitle = title ? `${title} | PadSmash` : 'PadSmash | Achetez, vendez, smashez !';
  const defaultDesc = "La marketplace entre passionnés de padel. Raquettes d'occasion, paiement sécurisé, 0% commission vendeur.";
  const desc = description || defaultDesc;
  const img = image || '/assets/padsmash_logo_main.png';

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement('meta'); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', desc);
    setMeta('property', 'og:type', type);
    setMeta('property', 'og:url', fullUrl);
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', desc);
    setMeta('property', 'og:image', img);
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', desc);
    setMeta('name', 'twitter:image', img);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.setAttribute('rel', 'canonical'); document.head.appendChild(canonical); }
    canonical.setAttribute('href', fullUrl);

    let ldScript = document.getElementById('seo-jsonld');
    if (jsonLd) {
      if (!ldScript) { ldScript = document.createElement('script'); ldScript.id = 'seo-jsonld'; ldScript.type = 'application/ld+json'; document.head.appendChild(ldScript); }
      ldScript.textContent = JSON.stringify(jsonLd);
    } else if (ldScript) {
      ldScript.remove();
    }
  }, [fullTitle, desc, fullUrl, type, img, jsonLd]);

  return null;
};

export default SEO;
